import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Feed from './Feed';
import * as qs from "query-string";

const appRoot = document.getElementById('root');
const feed = String(qs.parse(window.location.search)["calendar_feed"]);
console.log(`feed: ${feed}`);
if(appRoot)
  ReactDOM.render(<App feed={feed}/>, appRoot);

const feedRoot = document.getElementById('feed-root');

if(feedRoot) {
  const f = feedRoot.getAttribute("data-feed") || "hfcs";
  ReactDOM.render(<Feed feed={f} />, feedRoot);
}
